import React from 'react';

const Controls = ({
  isAudioMuted,
  isVideoOff,
  isSharingScreen,
  toggleAudio,
  toggleVideo,
  toggleScreenShare,
  leaveMeeting
}) => {
  return (
    <div className="controls" style={{ gap: '0.5rem' }}>
      {/* Microphone toggle */}
      <button 
        className={`control-btn ${isAudioMuted ? '' : 'active'}`}
        onClick={toggleAudio}
        title={isAudioMuted ? 'Unmute' : 'Mute'}
        aria-label={isAudioMuted ? 'Unmute' : 'Mute'}
      >
        {isAudioMuted ? (
          <i className="fas fa-microphone-slash"></i>
        ) : (
          <i className="fas fa-microphone"></i>
        )}
      </button>
      
      {/* Camera toggle */}
      <button 
        className={`control-btn ${isVideoOff ? '' : 'active'}`}
        onClick={toggleVideo}
        title={isVideoOff ? 'Turn on camera' : 'Turn off camera'}
        aria-label={isVideoOff ? 'Turn on camera' : 'Turn off camera'}
      >
        {isVideoOff ? (
          <i className="fas fa-video-slash"></i>
        ) : (
          <i className="fas fa-video"></i>
        )}
      </button>
      
      {/* Screen sharing toggle */}
      <button 
        className={`control-btn ${isSharingScreen ? 'active' : ''}`}
        onClick={toggleScreenShare}
        title={isSharingScreen ? 'Stop sharing' : 'Share screen'}
        aria-label={isSharingScreen ? 'Stop sharing' : 'Share screen'}
      >
        <i className="fas fa-desktop"></i>
      </button>
      
      {/* Leave meeting button */}
      <button 
        className="control-btn danger"
        onClick={leaveMeeting}
        title="Leave meeting"
        aria-label="Leave meeting"
      >
        <i className="fas fa-phone-slash"></i>
      </button>
    </div>
  );
};

export default Controls;
